import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";
import { isEmpty, union } from "lodash-es";

import { TranslationAction } from "./translation.action";
import { TranslationState } from "./translation.model";

const INITIAL_STATE: TranslationState = {
	isBusy: false,
	isClientLoaded: false,
	groupsAvailable: [],
};

/**
 * @deprecated - [fabric-deprecated]
 */
export const translationReducer = createReducer(
	INITIAL_STATE,
	on(TranslationAction.init, (state, { payload }) => updateState(state, { language: payload })),
	on(TranslationAction.get, (state) => updateState(state, { isBusy: true })),
	on(TranslationAction.getFail, (state) => updateState(state, { isBusy: false })),
	on(TranslationAction.getSuccess, (state, { payload }) => {
		if (isEmpty(payload.translations)) {
			return updateState(state, { isBusy: false });
		}

		return updateState(state, {
			isBusy: false,
			translations: updateState(state.translations, payload.translations),
			groupsAvailable: union(state.groupsAvailable, payload.groups),
		});
	}),
	on(TranslationAction.setClientLoaded, (state) => updateState(state, { isClientLoaded: true }))
);
